import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"

export const AusschreibungsblattAd = ({ name }) => {
  const { ausschreibungsblattBBMockup, ausschreibungsblattNOMockup } =
    useStaticQuery(graphql`
      {
        ausschreibungsblattBBMockup: file(
          name: { eq: "mockup-ausschreibungsblatt-bb" }
        ) {
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, AVIF]
              height: 300
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        ausschreibungsblattNOMockup: file(
          name: { eq: "mockup-ausschreibungsblatt-no" }
        ) {
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, AVIF]
              height: 300
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
      }
    `)
  const bb = ["Berlin", "Brandenburg"]
  const bundesländer_nord_ost = [
    "Bremen",
    "Hamburg",
    "Mecklenburg-Vorpommern",
    "Niedersachsen",
    "Sachsen",
    "Sachsen-Anhalt",
    "Schleswig-Holstein",
    "Thüringen",
  ]
  return (
    <React.Fragment>
      {bb.includes(name) ? (
        <React.Fragment>
          <hr />
          <div className="section">
            <div className="container">
              <div className="columns is-centered is-vcentered ">
                <div className="column is-6">
                  <h2 className="title is-3 is-spaced">
                    Ausschreibungsblatt Brandenburg-Berlin
                  </h2>

                  <p className="has-text-weight-bold">
                    Mit unserem Ausschreibungsblatt Brandenburg-Berlin erhalten
                    Sie alle Ausschreibungen aus der Region in Druckform.
                  </p>
                  <br />

                  <p>
                    Die jeden Montag erscheinende Druckausgabe informiert Sie
                    zuverlässig über aktuelle Ausschreibungen für Bau-, Liefer-
                    und Dienstleistungen in Brandenburg und Berlin. Ergänzt wird
                    die Ausgabe mit Informationen über private und gewerbliche
                    Bauvorhaben.
                  </p>
                  <br />
                  <Link
                    to={"/ausschreibungsdienste/preise#ausschreibungsblatt"}
                    className="button is-mitternachtsblau is-outlined"
                  >
                    Mehr Informationen
                  </Link>
                </div>

                <div className="column is-offset-1 has-text-centered">
                  <Link
                    to={"/ausschreibungsdienste/preise#ausschreibungsblatt"}
                  >
                    <GatsbyImage
                      image={
                        ausschreibungsblattBBMockup.childImageSharp
                          .gatsbyImageData
                      }
                      alt="B_I ausschreibungsblatt"
                      title="B_I ausschreibungsblatt"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </React.Fragment>
      ) : bundesländer_nord_ost.includes(name) ? (
        <React.Fragment>
          <hr />
          <div className="section">
            <div className="container">
              <div className="columns is-centered is-vcentered ">
                <div className="column is-6">
                  <h2 className="title is-3 is-spaced">
                    Ausschreibungsblatt Nord-Ost
                  </h2>

                  <p className="has-text-weight-bold">
                    Mit unserem B_I ausschreibungsblatt Nord-Ost erhalten Sie
                    alle Ausschreibungen aus Nord- und Ostdeutschland.
                  </p>
                  <br />

                  <p>
                    Die Druckausgabe erscheint drei mal pro Woche je am Montag,
                    Mittwoch und Freitag und informiert Sie zuverlässig über
                    aktuelle Ausschreibungen für Bau-, Liefer- und
                    Dienstleistungen in Schleswig-Holstein, Hamburg,
                    Niedersachsen, Bremen, Mecklenburg-Vorpommern, Brandenburg,
                    Berlin, Sachsen, Sachsen-Anhalt und Thüringen. Ergänzt wird
                    die Ausgabe mit Informationen über private und gewerbliche
                    Bauvorhaben sowie Nachrichten vom Bau und zum Vergabewesen.
                  </p>
                  <br />
                  <Link
                    to={"/ausschreibungsdienste/preise#ausschreibungsblatt"}
                    className="button is-mitternachtsblau is-outlined"
                  >
                    Mehr Informationen
                  </Link>
                </div>

                <div className="column is-offset-1 has-text-centered">
                  <Link
                    to={"/ausschreibungsdienste/preise#ausschreibungsblatt"}
                  >
                    <GatsbyImage
                      image={
                        ausschreibungsblattNOMockup.childImageSharp
                          .gatsbyImageData
                      }
                      alt="B_I ausschreibungsblatt"
                      title="B_I ausschreibungsblatt"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  )
}
